import { Alert, Box, Button, Text } from '@factorialco/deprecated-design-system'
import { BACKEND_DATE_FORMAT } from 'config/Vars'
import { DatevLaudsLoginDocument, DatevLaudsLogoutDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { stringToDate } from 'modules/core/lib/dates'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  owner?: string | null
  createdAt: string
  companyId: number
  accessId: number
}

export const Logout = ({ owner, createdAt, companyId, accessId }: Props) => {
  const [DatevLogout] = useMutation(DatevLaudsLogoutDocument, {
    extractorFn: (data) =>
      data.integrationsDatevLaudsMutations.deleteIntegrationsdatevlaudsOauthToken,
    refetchQueries: [DatevLaudsLoginDocument],
  })

  const logout = async () => {
    const result = await DatevLogout({
      variables: {
        companyId: companyId,
        accessId: accessId,
      },
    })

    const handled = handleResult(result, () => undefined)
    if (!handled.success) {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('common.error'),
      })
    }
  }

  const syncedBy = owner ? owner : i18n.t('common.unknown')

  // transform date format from 04/30/2025 to 30.04.2025
  const syncedDate = stringToDate(createdAt, 'backend_datetime')
    .format(`${BACKEND_DATE_FORMAT}`)
    .split('-')
    .reverse()
    .join('.')

  return (
    <Alert color="note">
      <Box flexDirection="column" gap="s16">
        <Text.Normal>
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.login.synced_by',
            {
              synced_by: syncedBy,
              synced_date: syncedDate,
            }
          )}
        </Text.Normal>
        <Button type="secondary" onClick={() => logout()}>
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.login.logout'
          )}
        </Button>
      </Box>
    </Alert>
  )
}
